import { render, staticRenderFns } from "./secondary-parameter-diagram.vue?vue&type=template&id=3b25e75e"
import script from "./secondary-parameter-diagram.vue?vue&type=script&lang=ts"
export * from "./secondary-parameter-diagram.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports